module.exports = __webpack_public_path__ + "static/img/p2.9308f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p2.png
// module id = UKQQ
// module chunks = 0